import { buttomBtnInit, initGetBonusMobileBtn } from "./modules/functions.js";

$(function () {
  $(".rating__nav__sort__dropdown").click(function () {
    $(this).next().toggleClass("bonus__sort__menu__new--active");

    return false;
  });

  $(".rating__inner__tab__link").on("click", function () {
    $(".rating__inner__tab__link, .bonus__sort__item--link").removeClass(
      "rating__inner__tab__link--active"
    );

    $(this).addClass("rating__inner__tab__link--active");

    $(".bricks").hide();

    $($(this).attr("href")).show();

    return false;
  });

  $(document).mouseup(function (e) {
    var dropdown = $(".bonus__sort__item--dropdown");
    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
      dropdown.removeClass("bonus__sort__item--active");
    }
  });

  $("#cookiesAccept").click(function () {
    $.ajax({
      method: "POST",
      url: "/ajax/setcookieagree",
      data: { cookieAgree: "" },
    }).done(function () {
      $(".cookies").css("display", "none");
      buttomBtnInit();
      initGetBonusMobileBtn();
    });

    return false;
  });

  $(".mask").click(function () {
    $(".whole__left .filter").css("display", "block");
  });

  $("#filter__pannel__reset").click(function () {
    mSearch2.reset();

    return false;
  });

  $(".comments__bk__stars span").hover(function () {
    $(this).prevAll().toggleClass("yellow");
  });

  $(document).on("mse2_load", function (e, data) {
    //console.log(e, data);

    let svgRadials = document.querySelectorAll(".radial-progress");

    if (svgRadials) {
      svgRadials.forEach(function (element, index) {
        element.querySelector(".complete").removeAttribute("style");
      });
    }
  });

  // $("#closeBanner").click(function () {
  //   $.ajax({
  //     method: "POST",
  //     url: "/ajax/setbottombanner",
  //     data: { bottomBanner: "" },
  //   }).done(function () {});
  // });

  $("#closeBannerLine").click(function () {
    $(".banner__line").css("display", "none");
    $.ajax({
      method: "POST",
      url: "/ajax/setlinebanner",
      data: { lineBanner: "" },
    }).done(function () {});
  });

  setTimeout(function () {
    $(".gift-count").addClass("gift-count-a");
  }, 1500);

  $(".best__nav__item a").on("click", function (event) {
    event.preventDefault();

    $(".best__nav__item").removeClass("best__nav__item--active");

    $(this).parent().addClass("best__nav__item--active");

    $(".best__body").hide();

    $($(this).attr("href")).show();

    let svgRadials = document.querySelectorAll(".radial-progress");

    if (svgRadials) {
      svgRadials.forEach(function (element, index) {
        element.querySelector(".complete").removeAttribute("style");
        element.querySelector(".complete").classList.remove("completed");
        element.querySelector(".complete").classList.remove("complete");
      });

      let halfHeight = window.innerHeight / 2;

      svgRadials.forEach(function (element, index) {
        if (
          !element.querySelector(".complete").classList.contains("completed")
        ) {
          if (element.getBoundingClientRect().top < halfHeight) {
            // Get percentage of progress

            let percent = element.dataset.percentage;

            // Get radius of the svgs circle.complete

            let radius = element.querySelector(".complete").getAttribute("r");

            // Get circumference (2πr)

            let circumference = 2 * Math.PI * radius;

            // Get stroke-dashoffset value based on the percentage of the circumference

            let strokeDashOffset =
              circumference - (percent * circumference) / 100;

            element.querySelector(".complete").style.strokeDashoffset =
              strokeDashOffset;

            element.querySelector(".complete").classList.add("completed");
          }
        }
      });
    }
  });

  $(".content__show__more").click(function (evt) {
    evt.preventDefault();
    const customSectionIntrotext = $(this).parents(".custom__section");
    customSectionIntrotext.addClass("custom__section--show");
    $(this).hide();
  });

  $(".shool__tab").click(function () {
    $(this).toggleClass("shool__tab--active");
  });

  $(".school__list__item__block:first-child .shool__tab").addClass(
    "shool__tab--active"
  );

  $(".profile__archive__tab").click(function () {
    $(this)
      .parents(".profile__archive__item")
      .toggleClass("profile__archive__item--active");
  });

  $(".sidebar__stats__head").click(function () {
    $(this)
      .parents(".sidebar__stats__block")
      .toggleClass("sidebar__stats__block--active");
  });

  $(".sidebar__stats__close").click(function () {
    $(".mask").removeClass("mask--active");
    $("html").removeClass("noscroll");
    $("#sidebarStats").removeClass("active");
  });

  $("#forecastCreateBtn").click(function (evt) {
    evt.preventDefault();
    $(".mask").addClass("mask--active");
    $("html").addClass("noscroll");
    $("#sidebarStats").addClass("active");
  });

  $(".rating__table__line--exsclusive")
    .prev()
    .addClass("rating__table__line--noafter");

  $(".resource__vote__btn").click(function (evt) {
    evt.preventDefault();

    const docId = $(this).data("docid");
    const voteVal = $(this).data("vote");

    $.ajax({
      method: "POST",
      url: "/ajax/resourcesetvote",
      data: { docId: docId, voteVal: voteVal },
    }).done(function (resp) {
      let respObj = jQuery.parseJSON(resp);

      if (respObj.type === "success") {
        $.jGrowl(respObj.message, { theme: "tickets-message-success" });

        let likesCount = respObj.likesCount;

        let dislikesCount = respObj.dislikesCount;

        $(".resource__vote__btn[data-vote='1']").text(likesCount);
        $(".resource__vote__btn[data-vote='0']").text(dislikesCount);
      } else if (respObj.type === "error") {
        $.jGrowl(respObj.message, { theme: "tickets-message-error" });
      }
    });
  });

  $(".header__bk__contain__btn").click(function (evt) {
    evt.preventDefault();
    $(this).toggleClass("header__bk__contain__btn--active");
  });

  $(".header__bk__contain__item").click(function () {
    const headerBkContain = $(this).parents(".header__bk__contain");
    const headerBkContainBtn = headerBkContain.find(
      ".header__bk__contain__btn"
    );

    headerBkContainBtn.removeClass("header__bk__contain__btn--active");
  });

  $(document).mouseup(function (evt) {
    const headerBkContainBtn = $(".header__bk__contain__btn");
    if (
      !headerBkContainBtn.is(evt.target) &&
      headerBkContainBtn.has(evt.target).length === 0
    ) {
      headerBkContainBtn.removeClass("header__bk__contain__btn--active");
    }
  });

  $("#comment-form-placeholder .comments__form__textarea").on(
    "focus",
    function () {
      $(".comments__form").addClass("comments__form--active");
      $(".comments__form__bot").slideDown();
    }
  );

  // мобильное меню, табы
  if ($(window).width() < 1200) {
    $(".main-menu__link--deeper").on("click", function (evt) {
      evt.preventDefault();

      const mainMenuItem = $(this).parents(".main-menu__item");
      mainMenuItem.toggleClass("main-menu__item--open");
    });

    $(".main-menu__inner--deeper").click(function (evt) {
      evt.preventDefault();

      const mainMenuWrapper = $(this).parents(".main-menu__wrapper");
      mainMenuWrapper.toggleClass("main-menu__wrapper--open");
    });
  }

  const menuListOffset = 8;
  const menuListWidth = 318;
  // переносит выпадающее меню налево, если не хватает места
  $(".main-menu__link").hover(function () {
    const navListInner = $(this).siblings(".main-menu__list");

    if (navListInner.length) {
      const thisOffset =
        $(window).width() - ($(this).offset().left + $(this).outerWidth());
      const navListInnerWidth = navListInner.width();

      const navListInnerRightOffset =
        $(window).width() -
        (navListInner.offset().left + navListInner.outerWidth());
      const navListInner2 = navListInner.find(".main-menu__list");
      const navListInner2Width = navListInner2.width();

      if (thisOffset < navListInnerWidth) {
        navListInner.css("left", "auto");
        navListInner.css("right", "-20px");
      } else {
        navListInner.css("left", "-20px");
        navListInner.css("right", "auto");
      }

      if (navListInnerRightOffset < navListInner2Width) {
        navListInner2.css("left", -menuListWidth - menuListOffset + "px");
      } else {
        navListInner2.css("left", menuListWidth - menuListOffset + "px");
      }
    }
  });

$(document).on("click", ".rating__table__btn__show", function (evt) {
  evt.preventDefault();
  const $btn = $(this);
  const ratingTableLine = $btn.parents(".rating__table__line");
  ratingTableLine.toggleClass("rating__table__line--active");
  const currentLabel = $btn.attr("aria-label");
  $btn.attr(
    "aria-label",
    currentLabel === "Показать больше" ? "Показать меньше" : "Показать больше"
  );
});


  $(document).on("click", ".books__app__open", function (evt) {
    evt.preventDefault();
    const currBookLine = $(this).parents(".books__app");
    currBookLine.toggleClass("books__app--active");
  });

  const forecastSearchSport = $("#sport");
  const forecastSearchDay = $("#day");
  $(".forecast-search__change").on("change", function (evt) {
    evt.preventDefault();

    if (forecastSearchSport.val() && forecastSearchDay.val()) {
      $.ajax({
        method: "POST",
        url: "/ajax/forecastsearch",
        data: {
          sport: forecastSearchSport.val(),
          day: forecastSearchDay.val(),
        },
      }).done(function (resp) {
        $("#forecastSearchResult").html(resp);
      });
    }
  });

  $("#ratingSort").change(function () {
    $.ajax({
      method: "POST",
      url: "/ajax/sortbk",
      data: {
        sortby: $(this).val(),
      },
    }).done(function (resp) {
      $("#mse2_results").html(resp);
    });
  });

  if ($("#ratingSort").length) {
    $(document).on("mse2_load", function (e, data) {
      $("#ratingSort").val("title");
      $("#ratingSort").trigger("change");
    });
  }

  $(document).on("submit", ".modal__bk__reviews__form", function (evt) {
    $("#bkReviewsModal .modal__bk__reviews").html(
      '<p class="modal__bk__reviews__succes">Спасибо! Отзыв отправлен на модерацию.</p>'
    );
  });

  // закрытие ссылок js
  $(document).on("click", "[data-href]", function () {
    const thisdata = $(this).attr("data-href");

    window.location.href = thisdata;
  });

  // открытие таба в таблице рейтинга
  $(".top-rating__show").click(function (evt) {
    evt.preventDefault();

    const topRatingItem = $(this).parents(".top-rating__item");
    const topRatingBody = topRatingItem.find(".top-rating__body");

    topRatingItem.toggleClass("top-rating__item--active");
    topRatingBody.slideToggle();
  });

  $(document).on("click", ".bk-card__more", function (evt) {
    evt.preventDefault();
    const bkCard = $(this).parents(".bk-card");
    const bkCardBot = bkCard.find(".bk-card__bot");
    bkCard.toggleClass("bk-card--active");
    bkCardBot.slideToggle(300);
  });

  // табы в рейтинге сайдабра
  $(".sidebar-menu__link--tab").click(function (evt) {
    evt.preventDefault();

    $(this).toggleClass("sidebar-menu__link--active");
    const innerMenu = $(this).siblings(".sidebar-menu__inner");
    innerMenu.slideToggle();
  });

  // кнопка развернуть в контенте
  $(".content__show").click(function (evt) {
    evt.preventDefault();

    const content = $(this).parents(".content");
    const contentHidden = content.find(".content__hidden");
    contentHidden.addClass("content__hidden--show");
    $(this).hide();
  });

  // Переключение табов у блока "Платежные системы"
  $("[data-payment-tab]").click(function (evt) {
    $(".payment-table__btn--active").removeClass("payment-table__btn--active");
    $(this).addClass("payment-table__btn--active");
    const tabId = $(this).data("payment-tab");
    $(".payment-table__tab--active").removeClass("payment-table__tab--active");
    $(tabId).addClass("payment-table__tab--active");
  });

  // Показывать нижний баннер после 20 секунд на сайте
  if ($(".banner__bot").length) {
    setTimeout(() => {
      $(".banner__bot").show();
      buttomBtnInit();
      initGetBonusMobileBtn();
    }, 20000);
  }
});

$(".forecast__section__tab").click(function (evt) {
  evt.preventDefault();
  $(".forecast__section__tab").removeClass(
    "custom__section__nav__item--active"
  );
  $(this).addClass("custom__section__nav__item--active");
  const sportId = $(this).data("sport-id");
  $(".forecasts__wrapper").html(
    '<p class="forecast__response__text">Идет загрузка...</p>'
  );
  $.ajax({
    method: "POST",
    url: "/ajax/forecastsload",
    data: { sportId: sportId },
  }).done(function (resp) {
    if (resp != "") {
      $(".forecasts__wrapper").html(resp);
    } else {
      $(".forecasts__wrapper").html(
        '<p class="forecast__response__text">По данному виду спорта прогнозов нет</p>'
      );
    }
  });
});

$("[data-modal-bonus]").click(function (evt) {
  evt.preventDefault();
  const modalId = $(this).data("modal-bonus");
  const bkId = $(this).data("bk-id");

  $(modalId).addClass("modal--active");
  $(".mask").addClass("mask--active");
  $("html").addClass("noscroll");

  $.ajax({
    method: "POST",
    url: "/ajax/modalbonusload",
    data: { bkId: bkId },
  }).done(function (resp) {
    $(".modal__bonus").html(resp);
  });
});

$(".comments__item__show__btn").click(function (evt) {
  evt.preventDefault();
  const commentsItem = $(this).parents(".comments__item");
  commentsItem.toggleClass("comments__item--active");
});

$(".bk__reviews__select__header").click(function () {
  $(".bk__reviews__select").toggleClass("bk__reviews__select--active");
});

$(document).on("click", ".bk__reviews__select__item", function () {
  const thread = $(this).data("thread");
  $(".bk__reviews__select__value").text($(this).text());
  $("#bkId").val(thread);
  $(".bk__reviews__select__item").removeClass(
    "bk__reviews__select__item--selected"
  );
  $(this).addClass("bk__reviews__select__item--selected");
  $(".bk__reviews__select").removeClass("bk__reviews__select--active");

  $.ajax({
    method: "POST",
    url: "ajax/bkreviewsform",
    data: { thread: thread },
  }).done(function (resp) {
    $(".modal__bk__reviews__form__wrapper").html(resp);

    var stars = jQuery(".ec-rating").find(".ec-rating-stars>span");
    stars.on("touchend click", function (e) {
      var starDesc = jQuery(this).data("description");
      jQuery(this)
        .parent()
        .parent()
        .find(".ec-rating-description")
        .html(starDesc)
        .data("old-text", starDesc);
      jQuery(this)
        .parent()
        .children()
        .removeClass("active active2 active-disabled");
      jQuery(this).prevAll().addClass("active");
      jQuery(this).addClass("active");
      // save vote
      var storageId = jQuery(this).closest(".ec-rating").data("storage-id");
      jQuery("#" + storageId).val(jQuery(this).data("rating"));
    });
    stars.hover(
      // hover in
      function () {
        jQuery(this).addClass("active").removeClass("active-disabled");
        jQuery(this)
          .prevAll()
          .addClass("active")
          .removeClass("active-disabled");
      }
    );

    // Заного инициализируем селекты
    if ($(".modal__review__select").length) {
      if ($(".modal__review__select").length > 1) {
        $(".modal__review__select").each(function () {
          let $this = $(this).not(".select-search");
          $this.select2({
            minimumResultsForSearch: -1,
            dropdownCssClass: "modal__review__select__container",
          });
        });
      } else {
        $(".modal__review__select").select2({
          minimumResultsForSearch: -1,
          dropdownCssClass: "modal__review__select__container",
        });
      }
    }
  });
});

// Квиз
$(".question__step__btn").click(function (evt) {
  evt.preventDefault();

  const currentStep = $(this).parents(".question__step");
  const currentStepNumber = +currentStep.data("step");
  const nextStepNumber = currentStepNumber + 1;
  $(".question__progress__item:nth-child(" + nextStepNumber + ")").addClass(
    "question__progress__item--active"
  );
  $(".question__step").removeClass("question__step--active");
  $("[data-step=" + nextStepNumber + "]").addClass("question__step--active");
});

//Tabs
$(document).on("click", ".whole__section__tab__header", function (evt) {
  evt.preventDefault();
  const tabHeadParent = $(this).parents(".whole__section--tab");
  tabHeadParent.toggleClass("whole__section--tab--active");
});

// scroll to anchore
$(".sliding-link").click(function (e) {
  e.preventDefault();
  const aid = $(this).attr("href");
  const headerHeight = $("#header").height();
  const GAP = 25;
  let space = headerHeight + GAP;

  if ($("#headerBk").length) {
    const headerBkHeight = $("#headerBk").height();
    space = space + headerBkHeight;
  }

  $("html,body").scrollTop($(aid).offset().top - space);
});
